import { render, staticRenderFns } from "./TrainingConfirm.vue?vue&type=template&id=832bde3a&scoped=true"
import script from "./TrainingConfirm.vue?vue&type=script&lang=js"
export * from "./TrainingConfirm.vue?vue&type=script&lang=js"
import style0 from "./TrainingConfirm.vue?vue&type=style&index=0&id=832bde3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832bde3a",
  null
  
)

export default component.exports